import APIClient from '@/shared/http/clients/api'

const resourceName = 'RETecnico'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetByName = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByName/${name}`, data, config)
const GetAll = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAll`, data, config)
const Post = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Post`, data, config)
const Update = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Update`, data, config)
const GetById = (funcionarioid, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetById/${funcionarioid}`, data, config)
const getGridTecnico = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllPagin?limit=${limit}&index=${index}`, data, config)
const Delete = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Delete`, data, config)

const TechnicianRepository = {
  GetByName,
  GetAll,
  Post,
  Update,
  GetById,
  getGridTecnico,
  Delete
}

export default TechnicianRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/technician.js